// Container related components
import styled from 'styled-components';
import BaseButton from '../../../../../../components/Common/Buttons/perfect-base-button/perfect-base-button.component';
import { THEME } from '../../../../../../themes';
import { hexToRgbA } from '../../../../../../utils/colors';
import { FLUENT_UI_EMOJIS } from '../../../../../../assets';

export const Icon = styled(FLUENT_UI_EMOJIS.LADDER)``;

export const ShowMoreButton = styled(BaseButton)`
  color: ${THEME.COLORS.PRIMARY};
  border: unset;
  border: 2px solid ${hexToRgbA(THEME.COLORS.CONTENT_A, THEME.OPACITY.GHOST)};
  margin-top: ${THEME.SPACING.TINY};
`;

export const TimelineLabelContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CareerTimelineLabel = styled.span`
  font-family: Gilroy;
  font-size: ${THEME.FONT_SIZE.TINY};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.5px;
  text-align: left;
  color: ${THEME.COLORS.CONTENT_A};
  opacity: ${THEME.OPACITY.MED};
  text-transform: uppercase;
`;
